var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-switch on=\"state\"> <div ng-switch-when=\"transclude\" ng-transclude=\"content\"></div> <div ng-switch-when=\"loading\">...</div> <div ng-switch-when=\"ready\" ng-bind-html=\"message\"></div> <div ng-switch-when=\"no-message\" ng-transclude=\"fallback\">{{ ultimateFallbackMessage }}</div> <div ng-switch-default></div> </div>";
var id1="winresMessage.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresMessage/winresMessage.html
// module id = 318
// module chunks = 2